var map = {
	"./menu_KYC.json": 2949,
	"./menu_RTP.json": 2950
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1105;


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/data ^\.\/menu_.*\.json$
// module id = 1105
// module chunks = 2